<div id="navbar-main">
  <!-- Fixed navbar -->
  <div class="navbar navbar-expand-lg navbar-dark bg-dark">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item dropdown" *ngIf="auth.isLoggedIn">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Users
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-user'" [routerLink]="['/users/user']" [queryParams]="{ filter: 'buyer' }">Buyer</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-user'" [routerLink]="['/users/user']" [queryParams]="{ filter: 'supplier' }">Supplier</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-user'" [routerLink]="['/users/user']" [queryParams]="{ filter: 'user' }">Uncompleted users</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-customer'" routerLink="/services/customer-quota-requests">Quota Requests</a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown" *ngIf="auth.isLoggedIn">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Companies
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-customer'"
                 routerLink="/users/company/customer/supplier-management" id="supplierManagement">
                Supplier Management
              </a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-customer'" [routerLink]="['/users/company']" [queryParams]="{ filter: 'buyer' }">Buyer</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-partner'" [routerLink]="['/users/company']" [queryParams]="{ filter: 'supplier' }">Supplier</a>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item" *ngIf="auth.isLoggedIn">
          <a class="nav-link" routerLink="/projects" id="projects">Projects</a>
        </li> -->
        <li class="nav-item dropdown" *ngIf="auth.isLoggedIn">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Projects
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-project'" routerLink="/projects">RFQ's</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-project'" routerLink="/projects/auctions">Auctions</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-service'" routerLink="/projects/categories">Services</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-user'" routerLink="/projects/users-by-categories">Users by categories</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-partner'" routerLink="/projects/vendor-reqs">Vendor Requests</a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/reviews">Reviews</a>
            </li>
          </ul>
        </li>
        <ng-container *ngIf="auth.isLoggedIn">
          <li class="nav-item dropdown" *appIsAuthorized="'view-activity'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
              Activities
              <span *ngIf="totalToDoActivities" class="badge badge-{{todoActivityStatus}}">
                {{totalToDoActivities}}
              </span>
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item" [routerLink]="['/services/activity-log']">Activity Logs</a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-activity-type'"
                   routerLink="/services/settings/activity-type">
                  Activity Types
                </a>
              </li>
            </ul>
          </li>
        </ng-container>

        <ng-container *ngIf="auth.isLoggedIn">
          <li class="nav-item" *appIsAuthorized="'view-vendor'">
            <a class="nav-link" routerLink="/services/vendors" id="services">Vendors</a>
          </li>
        </ng-container>
        <li class="nav-item dropdown" *ngIf="auth.isLoggedIn">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Other
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li>
              <a class="dropdown-item" routerLink="/tracking" id="tracking">Tracking</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-settings'" routerLink="/services/currency-config" id="currency">Currency Config</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-settings'" routerLink="/services/unlocks-config" id="unlocks-count">Unlocks Config</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-admin'" routerLink="/users/admin" id="admin">Admins</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-admin'" routerLink="/users/teams" id="teams">Teams</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-settings'" routerLink="/services/settings/review" id="settings">Settings</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-referral'" routerLink="/referrals">Referral Codes</a>
            </li>
            <li>
              <a class="dropdown-item" *appIsAuthorized="'view-industry'" routerLink="/services/industries">Industries</a>
            </li>
          </ul>
        </li>
        <ng-container *ngIf="auth.isLoggedIn">
          <li class="nav-item dropdown" *appIsAuthorized="'view-notification'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              Notification
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item" routerLink="/services/notification/inapp/templates">InApp Templates</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/services/notification/email/templates">Email Templates</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/services/notification/email/settings">Email Settings</a>
              </li>
            </ul>
          </li>
        </ng-container>
        <ng-container *ngIf="auth.isLoggedIn">
          <li class="nav-item dropdown" *appIsAuthorized="'view-project'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              Operations
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-all-invited-partners'" routerLink="/users/na-suppliers">NA Supplier Pipeline</a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-all-invited-partners'" routerLink="/projects/invited-partners">All invited Partners</a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-project'" routerLink="/projects/operation">Assigned RFQs</a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-partner'" routerLink="/users/operation">Supplier User Approval</a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-partner'"
                   [routerLink]="['/users/company/partner-docs']">
                  Supplier Documents
                </a>
              </li>
              <li>
                <a class="dropdown-item" *appIsAuthorized="'view-partner'"
                   [routerLink]="['/users/company/supplier-categories-revision']">
                  Supplier Categories Revision
                </a>
              </li>
            </ul>
          </li>
        </ng-container>
        <li class="nav-item" *ngIf="!auth.isLoggedIn">
          <a class="nav-link" routerLink="/signup" id="signup">Signup</a>
        </li>
        <li class="nav-item" *ngIf="!auth.isLoggedIn">
          <a class="nav-link" routerLink="/login" id="login">Login</a>
        </li>

      </ul>
      <ul class="nav navbar-nav navbar-right" *ngIf='auth.isLoggedIn'>
        <li class="nav-item">
          <a class="nav-link" routerLink="/profile">{{ auth.username }}</a>
        </li>
        <li>
          <img class='img-thumbnail user-image' *ngIf="imageUrl" src="{{imageUrl}}">
        </li>
        <li class="nav-item" *ngIf="auth.isLoggedIn">
          <a class="nav-link" (click)="auth.logout()" href="javascript:void(0);">Logout</a>
        </li>
      </ul>
    </div>
  </div>

</div>
<br />


<div class="loading" *ngIf='isLoading'>Loading&#8230;</div>

<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
